import React from 'react';
import { Line } from 'react-chartjs-2';
import { colors } from 'styles/theme';

import { LineCharDataProps } from '.';

import {ContainerGraph} from './styles';

const options = {
  responsive: true,
  legend: {
    display: true,
    position: 'bottom'
  },
  scale: {
    y: {
      type: "linear",
      min: 0,
      max: 100,
    }
  },
  font: {
    family: 'DM Sans',
    size: 14,
  },
  maintainAspectRatio: false
};

export const LineChart: React.FC<LineCharDataProps> = ({dataAttributes}) => {

  const labels = dataAttributes.map(item => item.verifiedAt).reverse();
  const values = dataAttributes.map(item => Number(item.score)).reverse();

   const data = {
     labels,
     datasets: [
       {
         label: 'Score',
         data: values,
         fill: true,
         backgroundColor: colors.support_one,
         borderColor: colors.primary,
         pointBorderWidth: 2,
         pointBackgroundColor: colors.support_one,
         pointBorderdColor: colors.support_one,
         pointHitRadius: 20, 
         pointRadius: 4,
         pointHoverRadius: 6,
         active: true,
       },
     ],
   }

  return (
    <ContainerGraph>
      <Line 
        data={data} 
        options={options}
      />  
    </ContainerGraph>
  )
};